export default "__VITE_ASSET__4f42659f__"